<template>
  <div class="about-page">
    <!-- ===== HERO ===== -->
    <section class="about-hero">
      <div class="about-hero-bg"></div>
      <div class="about-hero-overlay"></div>
      <div class="about-hero-content" :class="{ visible: heroVisible }">
        <span class="section-tag">Our Story</span>
        <h1>About <span>VENOM GYM</span></h1>
        <p>
          A professional fitness gym focused on building strength, confidence,
          and a healthy lifestyle through modern training programs — right in
          the heart of Alexandria.
        </p>
      </div>
      <div class="hero-bottom-bar"></div>
    </section>

    <!-- ===== MISSION ===== -->
    <section class="mission">
      <div class="mission-grid">
        <div class="mission-card" v-for="m in mission" :key="m.title">
          <div class="mission-icon" v-html="m.icon"></div>
          <h3>{{ m.title }}</h3>
          <p>{{ m.text }}</p>
        </div>
      </div>
    </section>

    <!-- ===== TRAINERS ===== -->
    <section class="trainers">
      <div class="section-header">
        <span class="section-tag">The Team</span>
        <h2>Our Professional Trainers</h2>
        <p class="section-sub">
          Expert coaches dedicated to your transformation
        </p>
      </div>
      <div class="trainers-grid">
        <div
          class="trainer-card"
          v-for="(t, i) in trainers"
          :key="t.name"
          :style="{ '--delay': i * 0.15 + 's' }"
        >
          <div class="trainer-img-wrap">
            <img :src="t.img" :alt="t.name" loading="lazy" />
            <div class="trainer-overlay"></div>
          </div>
          <div class="trainer-info">
            <div class="trainer-exp">{{ t.experience }}</div>
            <h3>{{ t.name }}</h3>
            <p>{{ t.bio }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== ADDRESS + MAP ===== -->
    <section class="location">
      <div class="section-header">
        <span class="section-tag">Find Us</span>
        <h2>Gym Location</h2>
      </div>
      <div class="location-inner">
        <div class="location-info">
          <div class="loc-item">
            <div class="loc-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div>
              <h4>Address</h4>
              <p>
                1 Street 18, Sidi Beshr Bahri<br />Montaza 2, Alexandria
                Governorate
              </p>
            </div>
          </div>
          <div class="loc-item">
            <div class="loc-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <div>
              <h4>Working Hours</h4>
              <p>
                Saturday – Thursday: 6:00 AM – 12:00 AM<br />Friday: 8:00 AM –
                10:00 PM
              </p>
            </div>
          </div>
          <div class="loc-item">
            <div class="loc-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"
                />
              </svg>
            </div>
            <div>
              <h4>Call Us</h4>
              <p>+20 xxx xxx xxxx</p>
            </div>
          </div>
          <router-link to="/contact" class="btn-primary"
            >Contact Us</router-link
          >
        </div>

        <div class="map-wrap">
          <iframe
            src="https://www.google.com/maps?q=31.2658149,29.9903841&hl=en&z=16&output=embed"
            width="100%"
            height="100%"
            style="border: 0"
            allowfullscreen
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AboutPage",
  data() {
    return {
      heroVisible: false,
      mission: [
        {
          icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>`,
          title: "Our Mission",
          text: "To empower every member with world-class equipment, expert coaching, and a motivating environment to exceed their limits.",
        },
        {
          icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>`,
          title: "Our History",
          text: "Founded with a passion for fitness, VENOM GYM has grown to become Alexandria's most trusted destination for strength and combat sports.",
        },
        {
          icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>`,
          title: "Our Community",
          text: "More than a gym — a family of determined individuals who push each other to become the best versions of themselves.",
        },
      ],
      trainers: [
        {
          name: "Momen Amer",
          experience: "8 Years Experience",
          bio: "Specialist in strength training and bodybuilding. Certified in advanced lifting techniques.",
          img: require("@/assets/kotsh1.png"),
        },
        {
          name: "Mohamed Amer",
          experience: "6 Years Experience",
          bio: "Certified personal trainer and nutrition coach. Expert in body transformation programs.",
          img: require("@/assets/kotsg.png"),
        },
        {
          name: "Omnea Salah",
          experience: "10 Years Experience",
          bio: "Professional fitness coach and crossfit expert. Specialist in female fitness programs.",
          img: "https://images.unsplash.com/photo-1550345332-09e3ac987658?auto=format&fit=crop&w=800&q=80",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.heroVisible = true;
    }, 100);
    this.setupReveal();
  },
  methods: {
    setupReveal() {
      const obs = new IntersectionObserver(
        (entries) =>
          entries.forEach((e) => {
            if (e.isIntersecting) e.target.classList.add("revealed");
          }),
        { threshold: 0.12 }
      );
      document
        .querySelectorAll(".trainer-card, .mission-card, .loc-item")
        .forEach((el) => obs.observe(el));
    },
  },
};
</script>

<style scoped>
.about-page {
  background: var(--black);
  color: var(--white);
}

.section-tag {
  display: inline-block;
  font-family: "Rajdhani", sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 10px;
  padding: 4px 14px;
  border: 1px solid rgba(204, 0, 0, 0.3);
  border-radius: 2px;
}
.section-header {
  text-align: center;
  margin-bottom: 56px;
}
.section-header h2 {
  font-family: "Bebas Neue", cursive;
  font-size: clamp(2.2rem, 5vw, 3.5rem);
  letter-spacing: 3px;
  line-height: 1;
}
.section-sub {
  color: var(--grey);
  font-size: 0.95rem;
  margin-top: 12px;
}

.btn-primary {
  display: inline-block;
  background: var(--red);
  color: #fff;
  padding: 13px 32px;
  font-family: "Bebas Neue", cursive;
  font-size: 1.1rem;
  letter-spacing: 2px;
  text-decoration: none;
  clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);
  transition: all 0.3s;
  margin-top: 20px;
  display: block;
  text-align: center;
}
.btn-primary:hover {
  background: var(--red-glow);
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(204, 0, 0, 0.4);
}

/* ===== HERO ===== */
.about-hero {
  position: relative;
  min-height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.about-hero-bg {
  position: absolute;
  inset: 0;
  background: url("https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1600&q=80")
    center/cover;
  filter: brightness(0.18) saturate(0.5);
  animation: heroPan 20s ease-in-out infinite alternate;
}
@keyframes heroPan {
  from {
    background-position: 40% center;
  }
  to {
    background-position: 60% center;
  }
}

.about-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(120, 0, 0, 0.3) 0%,
    transparent 50%,
    rgba(5, 5, 5, 0.5) 100%
  );
}
.about-hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 700px;
  padding: 0 6%;
  opacity: 0;
  transform: translateY(24px);
  transition: all 0.9s ease;
}
.about-hero-content.visible {
  opacity: 1;
  transform: translateY(0);
}
.about-hero-content h1 {
  font-family: "Black Ops One", cursive;
  font-size: clamp(3rem, 8vw, 6rem);
  line-height: 1;
  margin: 12px 0 20px;
}
.about-hero-content h1 span {
  color: var(--red);
}
.about-hero-content p {
  color: rgba(240, 240, 240, 0.65);
  font-family: "Cairo", sans-serif;
  font-size: 1.05rem;
  line-height: 1.8;
  max-width: 560px;
  margin: 0 auto;
}
.hero-bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--red), transparent);
}

/* ===== MISSION ===== */
.mission {
  padding: 80px 6%;
  background: var(--dark2);
}
.mission-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2px;
  max-width: 1200px;
  margin: 0 auto;
}
.mission-card {
  background: var(--steel);
  padding: 40px 32px;
  border-top: 2px solid transparent;
  transition: all 0.35s ease;
  opacity: 0;
  transform: translateY(20px);
}
.mission-card.revealed {
  opacity: 1;
  transform: translateY(0);
}
.mission-card:hover {
  border-top-color: var(--red);
  transform: translateY(-6px);
}
.mission-icon {
  width: 48px;
  height: 48px;
  color: var(--red);
  margin-bottom: 20px;
}
.mission-icon svg {
  width: 100%;
  height: 100%;
}
.mission-card h3 {
  font-family: "Bebas Neue", cursive;
  font-size: 1.4rem;
  letter-spacing: 2px;
  margin-bottom: 12px;
}
.mission-card p {
  color: var(--grey);
  font-size: 0.92rem;
  line-height: 1.7;
}

/* ===== TRAINERS ===== */
.trainers {
  padding: 100px 6%;
  background: var(--black);
}
.trainers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
}
.trainer-card {
  background: var(--steel);
  overflow: hidden;
  transition: all 0.4s ease;
  opacity: 0;
  transform: translateY(30px);
}
.trainer-card.revealed {
  opacity: 1;
  transform: translateY(0);
  transition-delay: var(--delay);
}
.trainer-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
}

.trainer-img-wrap {
  position: relative;
  height: 360px;
  overflow: hidden;
}
.trainer-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  transition: transform 0.6s ease;
  filter: saturate(0.8);
}
.trainer-card:hover .trainer-img-wrap img {
  transform: scale(1.06);
}
.trainer-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(5, 5, 5, 0.9) 0%, transparent 50%);
}

.trainer-info {
  padding: 20px 22px 24px;
}
.trainer-exp {
  font-family: "Rajdhani", sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 6px;
}
.trainer-info h3 {
  font-family: "Bebas Neue", cursive;
  font-size: 1.6rem;
  letter-spacing: 2px;
  margin-bottom: 8px;
}
.trainer-info p {
  color: var(--grey);
  font-size: 0.88rem;
  line-height: 1.6;
}

/* ===== LOCATION ===== */
.location {
  padding: 100px 6%;
  background: var(--dark2);
}
.location-inner {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 420px;
}
.location-info {
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.loc-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  opacity: 0;
  transform: translateX(-16px);
  transition: all 0.5s ease var(--delay, 0s);
}
.loc-item.revealed {
  opacity: 1;
  transform: translateX(0);
}
.loc-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  background: rgba(204, 0, 0, 0.12);
  border: 1px solid rgba(204, 0, 0, 0.25);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--red);
}
.loc-icon svg {
  width: 20px;
  height: 20px;
}
.loc-item h4 {
  font-family: "Bebas Neue", cursive;
  font-size: 1rem;
  letter-spacing: 2px;
  color: var(--white);
  margin-bottom: 4px;
}
.loc-item p {
  color: var(--grey);
  font-size: 0.875rem;
  line-height: 1.6;
}

.map-wrap {
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(204, 0, 0, 0.2);
  min-height: 400px;
}
.map-wrap iframe {
  display: block;
}

@media (max-width: 900px) {
  .location-inner {
    grid-template-columns: 1fr;
  }
  .map-wrap {
    min-height: 300px;
  }
}
@media (max-width: 580px) {
  .trainers-grid {
    grid-template-columns: 1fr;
  }
  .mission-grid {
    grid-template-columns: 1fr;
  }
}
</style>
